import clsx from "clsx"
import { FC } from "react"
import { PrivacyPolicyContent } from "@/ui/PrivacyPolicyContent"
import styles from "./PrivacyPolicy.module.scss"

export const PrivacyPolicy: FC = () => (
  <div className={clsx(styles.PrivacyPolicy)}>
    <div className={clsx(styles.PrivacyPolicy_content)}>
      <PrivacyPolicyContent />
    </div>
  </div>
)
